<template>
<div>

  <!-- <div class="primary--text text-center mb-2 font-sans">
	  <div class="font-weight-bold text-3xl mt-12 text-CsenGreen-500">Albo Tecnici CSEN</div>
	  <div class="font-weight-medium ">Centro Nazionalee Formazione Pescara</div>
	  <div class="font-weight-medium">(tesserini cartacei blu)</div>
  </div> -->

  <!-- Il menu l'ho messo in un componente, scelta non saggia ma veloce per il momento -->
  <v-main class="root-component">
    <router-view></router-view>

    <!-- Dialog di conferma -->
    <v-dialog v-model="dialogConferma.isVisibile" max-width="400" persistent>
      <v-card>
        <v-card-title>{{ dialogConferma.titolo }}</v-card-title>
        <v-card-text>{{ dialogConferma.testo }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogConferma.onAnnulla">Annulla</v-btn>
          <v-btn color="green" text @click="dialogConferma.onConferma">Conferma</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Mostro i messaggi di errore/successo -->
    <v-snackbar v-model="snackbar.isVisibile" :timeout="3000" :color="snackbar.tipo == 'success' ? 'green' : (snackbar.tipo == 'warning' ? 'orange' : 'red')">
      {{ snackbar.messaggio }}
      <template v-slot:actions>
        <v-btn variant="text" @click="snackbar.isVisibile = false">
          Chiudi
        </v-btn>
      </template>
    </v-snackbar>

  </v-main>

  <!-- <div>{{ isLogged }}</div>
  <v-btn @click="logga()">Logga</v-btn> -->

</div>
</template>

<script>
import mixin from '../mixin';
import store from '../store';

import { mapState } from 'vuex'; // Aggiungi questa importazione

export default {
  mixins: [mixin],
  data() {
    return {
      selectedMenuItem: null,

      isLoading: false,
      loginDialog: false,
      username: null,
      password: null,
      togglePassword: true
    };
  },

  computed: {
    ...mapState({ // lo stato della snackbar tra i computed per essere responsiva
      snackbar: state => state.snackbar,
      dialogConferma: state => state.dialogConferma
    }),

    items() {
      let items = [
        {
          icon: 'file-certificate',
          title: 'Tecnici',
          route_path: '/tecnici'
        }
      ];

      if (this.isLogged) {
        items.push(
          {
            icon: 'school',
            title: 'Corsi',
            route_path: '/corsi'
          },
          // {
          //   icon: 'chart-areaspline',
          //   title: 'Statistiche',
          //   route_path: '/statistiche'
          // },
        )
      }

      return items;
    }
  },

  watch: {
    isLogged(newVal, oldVal) {
      if (newVal) {
        const dark_theme = localStorage.getItem('dark_theme');
        if(dark_theme) {
          if (dark_theme == 'true') {
            this.$vuetify.theme.dark = true;
          }
          else {
            this.$vuetify.theme.dark = false;
          }
        }
      } else {
        this.$vuetify.theme.dark = false;
      }
    }
  },

  mounted() {
    
  },

  created() {
    store.commit('loadDarkMode');
  },

  methods: {
    logga() {
      console.log(this.username);
      console.log(this.password);
      // console.log(this.$options);
    },
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
    },
    // handleFunctionCall(functionName) {
    //   this[functionName]();
    // },
    doLogin: function() {
			this.alertType = null;
			this.message = null;
			this.isLoading = true;

			axios.post("/login", {
        username: this.username,
        password: this.password
      })
      .then(res => {
        if (res.data.alertType == "success") {
          store.commit('setIsLogged', true);
          this.loginDialog = false;
          this.username = null;
          this.password = null;
        }
        else {
          this.alertType = res.data.alertType;
          this.message = res.data.message;
        }
      })
      .catch(err => {
        this.alertType = "error";
        this.message = "Autenticazione fallita";
      })
      .finally(() => {
        this.isLoading = false;
      });
		},
    doLogout() {
      axios.get('/logout')
      .then(res => {
        this.$router.push({ name: 'tecnici'})
        store.commit('setIsLogged', false);
      })
      // .then(() => {
      //   // window.location.href = "/";
      //   this.$router.push({ name: 'tecnici'})
      // })
      // this.selectedMenuItem = null;
    },
    openLoginDialog() {
      this.loginDialog = true;
      // this.selectedMenuItem = null;
    }
  },
};
</script>

<style lang="scss">
.text_secondary_dark {
  color: #121212 !important;
}
.text_secondary_light {
  color: #fff !important;
}
</style>
